/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Desireddegree1Inputs */

const en__field_desireddegree1 = /** @type {(inputs: _Field_Desireddegree1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` desired Degree`)
};

const de__field_desireddegree1 = /** @type {(inputs: _Field_Desireddegree1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angestrebter Abschluss`)
};

/**
* | output |
* | --- |
* | "desired Degree" |
*
* @param {_Field_Desireddegree1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_desireddegree1 = /** @type {((inputs?: _Field_Desireddegree1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Desireddegree1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_desireddegree1(inputs)
	return de__field_desireddegree1(inputs)
});
export { _field_desireddegree1 as "_field_desiredDegree" }